import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles((theme) => ({
        root: {
          flexGrow: 1,
          width: '100%'
        },
        footerBackground:{
          background:"#f7f7f7"
        },
        CardBorder: {
          borderRadius: "15px"
      
        },
        companyHeadings: { backgroundColor: '#4688f0', color: '#fff' },
        heading: {
          fontSize: theme.typography.pxToRem(15),
          fontWeight: theme.typography.fontWeightRegular,
        },
        widthFill: { width: '100%' },
        customInputs: { width: '100%' },
        addPlus: {},
        addMinus: { margin: '0px !important'},
        profileImg: {}
      }));